<template>
  <div class="payout-trans-details">
    <div class="filter-right-container">
      <div class="filter-container-tag">
        {{ $t('components.activity') }}
      </div>
      <el-popover
        placement="bottom"
        trigger="click"
      >
        <div class="filter-section-container">
          <div id="filter-content" class="filter-content">
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('merchantAccount.create_time') }}</div>
              <el-date-picker
                v-model="search.times"
                class="filter-item-value"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00','23:59:59']"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('components.start_date')"
                :end-placeholder="$t('components.end_date')"
              />
            </div>
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('merchantAccount.complete_time') }}</div>
              <el-date-picker
                v-model="search.complete_times"
                class="filter-item-value"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00','23:59:59']"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('components.start_date')"
                :end-placeholder="$t('components.end_date')"
              />
            </div>

            <div class="filter-item">
              <div class="filter-item-label">
                {{ $t('merchant.merchant_name') }}
              </div>
              <SearchAgentSelect v-model="search.merchant_name" size="medium" :only-name="true" style="width: 100%" />
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('merchantAccount.transaction_status') }}</div>
              <el-select v-model="search.po_trans_status" class="filter-item-value" clearable>
                <el-option
                  v-for="(item,index) in poTransactionStatusMap"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>

<!--            <div class="filter-item">-->
<!--              <div class="filter-item-label">{{ $t('data.settlement_status') }}</div>-->
<!--              <el-select v-model="search.settlement_status" class="filter-item-value" clearable>-->
<!--                <el-option-->
<!--                  v-for="(item,index) in transactionSettlementStatusMap"-->
<!--                  :key="index"-->
<!--                  :label="item.label"-->
<!--                  :value="item.value"-->
<!--                />-->
<!--              </el-select>-->
<!--            </div>-->

            <div class="filter-item" />
          </div>

          <div class="filter-operate">
            <div class="filter-operate-right">
              <el-button class="search-btn mb-10" @click="onClickReset">{{ $t('components.clear') }}</el-button>
              <el-button class="search-btn mb-10" type="primary" icon="el-icon-search" @click="handleFilter">{{ $t('components.search') }}</el-button>
            </div>

          </div>
        </div>
        <el-button slot="reference" class="mb-10 mr-12" type="info" plain>   <svg-icon class-name="mr-10" icon-class="filter" />{{ $t('components.filter') }}</el-button>
      </el-popover>

      <div class="tableContainer">
        <!-- 列表 -->
        <el-table
          v-loading="listLoading"
          :data="tableData"
          stripe
          fit
          highlight-current-row
          style="width: 100%"
        >

          <el-table-column :label="$t('merchant.merchant_name')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.merchant_name }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('customerService.transaction_id')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.transaction_id }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('merchantAccount.merchant_order_id')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.merchant_order_id }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('merchantAccount.recipient_channel')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.recipient_channel }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('merchantAccount.amount')" align="center">
            <template slot-scope="scope">
              <span> {{ scope.row.po_trans_amount | toDivideWithDot }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('data.commission')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.agent_commission | toDivideWithDot }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('merchantAccount.po_trans_status')" min-width="150" align="center">
            <template slot-scope="scope">
              <el-tag class="tag-custom" :type="getPoTransactionStatusStyle(scope.row.po_trans_status)">{{ getPoTransactionStatusMap(scope.row.po_trans_status,scope.row.refund_type) }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column :label="$t('merchantAccount.create_time')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.transaction_create_time }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('merchantAccount.complete_time')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.transaction_return_time }}</span>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container">
          <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
        </div>
      </div>
    </div>
  </div></template>

<script>

import { fetchPayoutDetailInfo } from '@/api/settlement/settlement'
import { fetchDisbursementBankNameList } from '@/api/components/components'

import { poTransStatusWithRefundMap } from '@/utils/maps'
import { transactionSettlementStatusMap } from '@/maps/status.js'
import { filterEmptyAttr } from '@/utils/common'
import { appointDate } from '@/utils/index.js'
import SearchAgentSelect from '@/components/SearchAgentSelect'
export default {
  name: 'Payout_Trans_Details',
  components: {
    Paginator: () => import('@/views/components/Paginator'),
    SearchAgentSelect
  },
  data() {
    return {
      showFilterContent: true,
      search: {
        po_trans_status: null, // 交易状态,
        times: [appointDate(-3) + ' 00:00:00', appointDate() + ' 23:59:59'],
        complete_times: []
      },
      bankList: [],
      tableData: [],
      total_amount: 0,
      total_commission: 0,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      detailId: '',
      downloading: false
    }
  },
  computed: {
    poTransactionStatusMap() {
      let list = poTransStatusWithRefundMap()
      list = list.map(lm => {
        if (lm.value === 2) {
          lm.value = 125
        }
        return lm
      }).filter(item => item.value !== 1 && item.value !== 5)
      return list
    },
    getPoTransactionStatusMap() {
      return function(value, refund_type) {
        if (refund_type === 2) {
          value = 99
        }
        return poTransStatusWithRefundMap(value).label
      }
    },
    getPoTransactionStatusStyle() {
      return function(value) {
        return poTransStatusWithRefundMap(value).type
      }
    },
    transactionSettlementStatusMap() {
      return transactionSettlementStatusMap()
    }
  },
  created() {
    this.handleFilter()
    // this.getAllChannelList()
  },
  methods: {
    getAllChannelList() {
      fetchDisbursementBankNameList().then(res => {
        if (res.code === 10000) {
          this.bankList = res.data
        }
      })
    },
    getPayoutDetailInfo(params = {}) {
      this.listLoading = true
      fetchPayoutDetailInfo(params).then(res => {
        if (res.code === 10000) {
          const { list = [], total_amount, total_commission, total } = res.data || {}
          this.listQuery.total = total
          this.listQuery.page = params.page ? params.page : 1
          this.tableData = list
          this.total_amount = total_amount
          this.total_commission = total_commission
          this.total = total
        }
      }).finally(() => {
        this.listLoading = false
      })
    },

    getParams(otherParams = {}) {
      const { po_trans_status, recipient_channel, times = [], complete_times = [], merchant_order_id, transaction_id, app_name } = this.search
      let params = {
        start_date_time: times && times[0],
        end_date_time: times && times[1],
        complete_start_date_time: complete_times && complete_times[0],
        complete_end_date_time: complete_times && complete_times[1],
        mch_order_id: merchant_order_id,
        po_trans_status,
        recipient_channel,
        transaction_id,
        app_name,
        ...otherParams
      }

      params = filterEmptyAttr(params)
      return params
    },

    handleFilter(otherParams = {}) {
      if (!this.$commonFn.checkSubmitDateLimit(this.search.times, 15)) {
        this.$message.warning('The maximum date range  is limited to 15 days, please select again')
        return
      }
      if (!this.$commonFn.checkSubmitDateLimit(this.search.complete_times, 15)) {
        this.$message.warning('The maximum date range  is limited to 15 days, please select again')
        return
      }
      const params = this.getParams(otherParams)
      if (!params) {
        return
      }
      this.getPayoutDetailInfo(params)
    },

    onClickPaginator() {
      this.handleFilter(this.listQuery)
    },
    onClickFixedArrow() {
      this.showFilterContent = !this.showFilterContent
    },
    onClickReset() {
      this.search = {}
    }
  }
}
</script>

<style lang="scss" scoped>
.payout-trans-details{
  .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Poppins-Medium';
    color: #606266;
  }
  .filter-container{
    padding: 20px 0 0 20px;
  }
  .search-frame {
    width: 160px;
    margin-right: 5px;
  }
   .search-frame-order{
    width:200px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
  .picker{
    margin-right: 5px;
  }
  .mb-10{
    margin-bottom: 10px;
  }
  .detailTxt{
    font-size: 12px;
    color: #3579FF;
    text-decoration: underline;
     cursor: pointer;
  }
  .total-container{
    display: flex;
    border: 1px solid #D3D7DF;
    margin-bottom: 32px;
    .total-item{
      padding: 10px 0;
      flex: 1;
      text-align: center;
      border-right: 1px solid #D3D7DF;
      font-weight: 400;
      font-size: 14px;
      color: #4B5567;
    }
    .total-item:not(:last-child){
      border-right: 1px solid #D3D7DF;
    }
  }
  .total{
    border-top: 1px solid #D5D8DE;
    padding: 24px 24px 0 24px;
    &-title{
      font-size: 12px;
      line-height: 17px;
      color: #606266;
    }
    &-num{
      margin-top: 10px;
      padding-bottom: 20px;
      font-size: 16px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      line-height: 24px;
      color: #303133;
    }
  }

}

</style>
